export function countDecimals(value: number) {
  if (!value) return value;
  if (Math.floor(value) === value) return 0;
  return value.toString().split(".")[1]?.length || 0;
}

export const parseFloat4Digit = (num: string | number | null) => {
  if (!num) return num;
  const parseSplit = `${num}`.split(".");
  if (parseSplit.length > 1 && parseSplit[1].length > 4) {
    if (`${num}`.includes("e+")) {
      const strNum = `${num}`;
      const tmpNum = strNum.slice(0, strNum.indexOf("e+"));
      return Number(+tmpNum).toFixed(4);
    } else return Number(num).toFixed(4);
  } else {
    return Number(num);
  }
};

export const roundUpToNearestTen = (num: number) => {
  return Math.ceil(num / 10) * 10;
};

export const convertLastThreeDecimalToZero = (number: string) => {
  if (!number || typeof number !== "string") return number;

  const spliter = number.split(".");
  if (spliter.length != 2) return number;

  const decimalPart = spliter[1];
  const parseDecimalPart = decimalPart.slice(0, 1) + "000";
  return `${spliter[0]}.${parseDecimalPart}`;
};
